var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 74,
    viewBox: "0 0 50 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.48 53.36C41.92 60.48 39.58 62.98 36.14 66.95C33.23 70.32 30.66 72.36 26.84 72.36C23.02 72.36 20.45 70.32 17.54 66.95C15.18 64.23 13.23 62.2 11.75 58.9",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.38 47.82C49.06 51.88 46.14 57.41 42.86 56.4",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.14 35.68C20.84 44.87 7.26998 47.82 9.33998 61.68C-5.90002 50.16 2.46999 11.6 27.72 15.73C52.89 19.84 48.9 43.81 44.67 49.59C44.67 49.59 42.31 37.13 32.12 31.33",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 42.11C22.95 44.16 22.36 45.97 22.01 46.51C22.01 46.51 34.17 41.31 31.81 23",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 17.62C12.44 15.88 11.44 13.71 11.44 11.36C11.44 5.64 17.41 1 24.77 1C32.13 1 38.1 5.64 38.1 11.36C38.1 12.94 37.64 14.44 36.83 15.78",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioFemale);
export default __webpack_public_path__ + "static/media/radio-female.d67c0032d650cb3314ca5806507e8488.svg";
export { ForwardRef as ReactComponent };